import { MediaQuery as MQ } from '../app/media-query';

// padStart polyfill for ie11
if (!String.prototype.padStart) {
    String.prototype.padStart = function padStart(targetLength, padString) {
        targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
        padString = String((typeof padString !== 'undefined' ? padString : ' '));
        if (this.length > targetLength) {
            return String(this);
        }
        targetLength = targetLength - this.length;
        if (targetLength > padString.length) {
            //append to original to ensure we are longer than needed
            padString += padString.repeat(targetLength / padString.length);
        }
        return padString.slice(0, targetLength) + String(this);
    };
}

// Array.from polyfill for ie11
if (!Array.from) {
    Array.from = (function() {
        var toStr = Object.prototype.toString;
        var isCallable = function(fn) {
            return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
        };
        var toInteger = function(value) {
            var number = Number(value);
            if (isNaN(number)) {
                return 0;
            }
            if (number === 0 || !isFinite(number)) {
                return number;
            }
            return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
        };
        var maxSafeInteger = Math.pow(2, 53) - 1;
        var toLength = function(value) {
            var len = toInteger(value);
            return Math.min(Math.max(len, 0), maxSafeInteger);
        };

        // The length property of the from method is 1.
        return function from(arrayLike /*, mapFn, thisArg */ ) {
            // 1. Let C be the this value.
            var C = this;

            // 2. Let items be ToObject(arrayLike).
            var items = Object(arrayLike);

            // 3. ReturnIfAbrupt(items).
            if (arrayLike == null) {
                throw new TypeError('Array.from requires an array-like object - not null or undefined');
            }

            // 4. If mapfn is undefined, then let mapping be false.
            var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
            var T;
            if (typeof mapFn !== 'undefined') {
                // 5. else
                // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                if (!isCallable(mapFn)) {
                    throw new TypeError('Array.from: when provided, the second argument must be a function');
                }

                // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                if (arguments.length > 2) {
                    T = arguments[2];
                }
            }

            // 10. Let lenValue be Get(items, "length").
            // 11. Let len be ToLength(lenValue).
            var len = toLength(items.length);

            /*
            If IsConstructor(C) is true, then:
                a. Let A be the result of calling the [[Construct]] internal method of C with an argument list
                containing the single item len.
                b. Else, Let A be ArrayCreate(len).
            */
            var A = isCallable(C) ? Object(new C(len)) : new Array(len);

            // 16. Let k be 0.
            var k = 0;
            // 17. Repeat, while k < len… (also steps a - h)
            var kValue;
            while (k < len) {
                kValue = items[k];
                if (mapFn) {
                    A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                } else {
                    A[k] = kValue;
                }
                k += 1;
            }
            // 18. Let putStatus be Put(A, "length", len, true).
            A.length = len;
            // 20. Return A.
            return A;
        };
    }());
}

// Array.keys polyfill for ie11
if (!Array.keys) {
    Array.prototype.keys = function() {
        var k, a = [],
            nextIndex = 0,
            ary = this;
        k = ary.length;
        while (k > 0) a[--k] = k;
        a.next = function() {
            return nextIndex < ary.length ? {
                value: nextIndex++,
                done: false,
            } : {
                done: true,
            };
        };
        return a;
    };
}

// Array.includes polyfill for ie11
if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function(searchElement, fromIndex) {

            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            // 1. Let O be ? ToObject(this value).
            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If len is 0, return false.
            if (len === 0) {
                return false;
            }

            // 4. Let n be ? ToInteger(fromIndex).
            //    (If fromIndex is undefined, this step produces the value 0.)
            var n = fromIndex | 0;

            // 5. If n ≥ 0, then
            //  a. Let k be n.
            // 6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
            }

            // 7. Repeat, while k < len
            while (k < len) {
                // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                // b. If SameValueZero(searchElement, elementK) is true, return true.
                if (sameValueZero(o[k], searchElement)) {
                    return true;
                }
                // c. Increase k by 1.
                k++;
            }

            // 8. Return false
            return false;
        },
    });
}

// Object.assign polyfill for ie11
if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, 'assign', {
        value: function assign(target) { // .length of function is 2
            'use strict';
            if (target == null) { // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource != null) { // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true,
    });
}

// event.newURL support for IE
if (!window.HashChangeEvent) {
    (function(){
        var lastURL = document.URL;
        window.addEventListener('hashchange', (event) => {
            Object.defineProperty(event, 'oldURL', {
                enumerable: true,
                configurable: true,
                value: lastURL,
            });

            Object.defineProperty(event, 'newURL', {
                enumerable: true,
                configurable: true,
                value: document.URL,
            });

            lastURL = document.URL;
        });
    }());
}

// endsWith() polyfill for IE11
if (!String.prototype.endsWith) {
    String.prototype.endsWith = function(search, this_len) {
        if (this_len === undefined || this_len > this.length) {
            this_len = this.length;
        }

        return this.substring(this_len - search.length, this_len) === search;
    };
}

//custom scrollspy for card & deck pages
if (document.querySelector('tarot-card-bar a[href="#upright"]') && MQ.isMobile()) {
    window.addEventListener('scroll', () => {
        const container = document.querySelector('tarot-card-bar');
        const scrollPos = document.querySelector('article a[href="#upright"]').getBoundingClientRect().bottom;

        if (
            (scrollPos < 145 && !container.classList.contains('show-anchors'))
            ||
            (scrollPos >= 145 && container.classList.contains('show-anchors'))
        ) {
            container.classList.toggle('show-anchors');
        }
    });
}

setInterval(() => {
    const mobileStickyNav = document.querySelector('mobile-sticky-nav');
    const adAdhesion = document.getElementById('pmc-atlasmg-adhesion-bar');

    if (mobileStickyNav && MQ.isMobile()) {
        if (window.scrollY >= 154 && mobileStickyNav.style.bottom != '0px') {
            mobileStickyNav.style.bottom = 0;

            if (adAdhesion) {
                adAdhesion.style.bottom = '79px';
            }
        } else if (window.scrollY < 154 && mobileStickyNav.style.bottom != '-80px') {
            mobileStickyNav.style.bottom = '-80px';

            if (adAdhesion) {
                adAdhesion.style.bottom = 0;
            }
        }
    }
}, 500);
